import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SecondHeader from '../Layout/SecondHeader';
import SecondFooter from '../Layout/SecondFooter';
import AssessmentModal from '../Modal/AssessmentModal';
import './programs.css';

export default function Programs() {
  const [assessmentShow, setAssessmentShow] = useState(false);

  const buildProgramLink = (programLabel) =>
    `/cancer-recovery-management-online?program=${encodeURIComponent(programLabel)}#regForm`;

  return (
    <div className="programs-page">
      <SecondHeader />
      <AssessmentModal show={assessmentShow} onHide={() => setAssessmentShow(false)} />

      <section className="prog-hero">
        <div className="container">
          <h1 className="prog-hero-title">
            Programs designed to support you -{' '}
            <span className="prog-hero-sub">wherever you are in your journey</span>
          </h1>
        </div>
      </section>

      <section className="prog-intro">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <p>
                With more than 20 years of experience in health, recovery, clinical practice, and
                education, we have developed a structured and comprehensive system to support
                individuals facing cancer - before, during, and after treatment.
              </p>
              <p>
                Our programs are built on one principle: giving you clarity, guidance, and the right
                tools to take an active role in your health.
              </p>
              <p>
                Research shows that a significant proportion of cancer cases are influenced by
                lifestyle and early intervention. This means that informed choices, consistent
                support, and the right actions can make a meaningful difference.
              </p>
              <p>
                Whether your goal is prevention, support during treatment, or recovery, our programs
                are designed to meet you at your current stage - with the level of support you need.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="prog-cards-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <p className="prog-choose-label text-center">
                Choose the level of support and program that fits your needs.
              </p>
            </div>
          </div>
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-4 col-md-12 d-flex">
              <div className="prog-card w-100">
                <h3 className="prog-card-name">Fully Digital Program 12-Months</h3>
                <div className="prog-card-price">600 USD</div>
                <p className="prog-card-desc prog-card-emphasis">
                  A complete 12-month digital recovery program for individuals who want clear
                  structure, trusted guidance, and the freedom to work at their own pace.
                </p>
                <p className="prog-card-desc prog-card-emphasis">
                  You receive access to our online progress platform, developed over many years to
                  help individuals improve health, energy, strength, mindset, and daily direction.
                </p>
                <p className="prog-card-desc prog-card-emphasis">
                  The program includes guidance across 10 key recovery areas, including:
                </p>
                <ul className="prog-card-list">
                  <li>Physical health and progress tracking</li>
                  <li>Energy and fatigue management</li>
                  <li>Nutrition, vitamins and minerals</li>
                  <li>Strength and movement</li>
                  <li>Mental wellbeing and emotional balance</li>
                  <li>Stress reduction and motivation</li>
                  <li>Long-term health foundations</li>
                </ul>
                <p className="prog-card-suited prog-card-emphasis">
                  Designed for individuals who are ready to take ownership of their process while
                  following a clear and proven framework.
                </p>
                <div className="prog-card-actions">
                  <Link
                    to={buildProgramLink("Fully Digital Program 12-Months")}
                    className="prog-card-register-btn"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 d-flex">
              <div className="prog-card prog-card-featured w-100">
                <h3 className="prog-card-name">Digital Program + Mail Support</h3>
                <div className="prog-card-price">2,500 USD</div>
                <p className="prog-card-desc">
                  Includes full access to the complete 12-month digital program, featuring all 12
                  core modules covering key areas such as physical health, energy to help reduce
                  fatigue and restore vitality, mindset, emotional wellbeing, vitamins and minerals,
                  structure, and long-term recovery support.
                </p>
                <p className="prog-card-desc">
                  In addition, this program includes personal email support from an advisor
                  experienced with the program and recovery processes.
                </p>
                <p className="prog-card-desc">
                  You may send emails throughout your journey and receive individual feedback,
                  guidance, and answers based on your progress and needs.
                </p>
                <p className="prog-card-suited">
                  <em>
                    Particularly valuable for individuals in earlier stages who want the flexibility
                    of independent work, with trusted support available when needed.
                  </em>
                </p>
                <div className="prog-card-actions">
                  <Link
                    to={buildProgramLink("Digital Program + Mail Support")}
                    className="prog-card-register-btn"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12 d-flex">
              <div className="prog-card prog-card-platinum w-100 d-flex flex-column">
                <h3 className="prog-card-name" style={{ color: '#fff' }}>
                  Digital Program + Health Advisor 12-Months
                </h3>
                <div className="prog-card-price" style={{ color: '#b8e06a' }}>
                  4,900 USD
                </div>
                <p className="prog-card-desc" style={{ color: 'rgba(255,255,255,0.82)' }}>
                  Includes full access to the complete 12-month digital program, plus personal
                  email support and ongoing guidance from a dedicated Health Advisor.
                </p>
                <p className="prog-card-desc" style={{ color: 'rgba(255,255,255,0.82)' }}>
                  Included are 12 one-to-one online sessions (30 minutes each), providing a more
                  supported and responsive process with individual feedback and follow-up
                  throughout the year.
                </p>
                <p className="prog-card-suited" style={{ color: 'rgba(255,255,255,0.6)' }}>
                  <em>
                    Particularly valuable for individuals facing more complex situations, or for
                    those who value continuity, accountability, and tailored support over time.
                  </em>
                </p>
                <div className="prog-card-actions">
                  <Link
                    to={buildProgramLink("Digital Program + Health Advisor 12-Months")}
                    className="prog-card-register-btn prog-card-register-btn-light"
                  >
                    Register Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="prog-platinum-section" id="platinum-details">
        <div className="container">
          <div className="prog-platinum-inner">
            <p className="prog-platinum-label">Premium | Highly Personalised</p>
            <h2 className="prog-platinum-title">The Platinum Recovery Experience</h2>

            <p className="prog-platinum-desc">
              This offering is designed for individuals who require more than general guidance -
              those seeking a structured, highly personalized path forward.
            </p>
            <p className="prog-platinum-desc">
              We begin where it matters most: with a precise understanding of your current
              condition. Through in-depth assessment and clinical insight, we establish a clear
              foundation for the work ahead.
            </p>
            <p className="prog-platinum-desc">
              From there, we design a <strong style={{ color: '#b8e06a' }}>tailored recovery strategy</strong> -
              built entirely around your needs, circumstances, and capacity. Only what is relevant,
              realistic, and sustainable for you.
            </p>

            <p className="prog-platinum-feature-title">The experience includes:</p>
            <ul className="prog-platinum-list">
              <li>Comprehensive health assessments and evaluations</li>
              <li>Individually tailored strategies and guidance</li>
              <li>Personalized training and progression planning</li>
              <li>Practical tools for daily integration</li>
              <li>Continuous follow-up over a 12-month period</li>
              <li>One week of dedicated in-home support (up to 5 hours per day, 5 days)</li>
            </ul>

            <p className="prog-platinum-desc" style={{ marginTop: '20px' }}>
              Travel and hotel accommodation for your Recovery Specialist are included -
              ensuring a focused and professional presence, wherever you are based.
            </p>
            <p className="prog-platinum-desc">
              This is a committed, professional collaboration. We bring structure, experience,
              and clinical insight - you bring openness and a willingness to engage in
              meaningful change.
            </p>
            <p className="prog-platinum-desc">
              For individuals in stage 3 and stage 4, this level of depth, continuity, and
              precision is often essential.
            </p>

            <p className="prog-plat-bold">
              This is not a quick fix - it is where real impact is built.
            </p>

            <p className="prog-platinum-desc">
              It is a deliberate and carefully guided process, designed to support lasting
              change - and to expand what may be possible.
            </p>

            <p className="prog-platinum-feature-title" style={{ marginTop: '28px' }}>
              A broader perspective in recovery
            </p>
            <p className="prog-platinum-desc">
              Many individuals come to us after having received limited or uncertain outlooks.
            </p>
            <p className="prog-platinum-desc">
              We approach this with respect for both the diagnosis and the professionals
              involved - while recognizing that individual capacity for improvement varies
              significantly. Some go on to live longer than initially expected; in certain
              cases extending well beyond a decade.
            </p>
            <p className="prog-platinum-desc">
              Our role is to support a grounded sense of possibility - rooted in structure,
              science, and experience.
            </p>
          </div>
        </div>
      </section>

      <section className="prog-single-cta">
        <div className="container text-center">
          <p className="prog-cta-label">Ready to take the next step?</p>
          <p className="prog-cta-note">
            Each case is reviewed individually. If appropriate, a private consultation will be arranged.
          </p>
          <button className="prog-apply-btn" onClick={() => setAssessmentShow(true)}>
            Begin Confidential Assessment
          </button>
        </div>
      </section>

      <SecondFooter />
    </div>
  );
}
